import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import fetch from '../../utils/fetch';
import { setAbout } from '../../store/about';
import Loading from '../../components/Loading';
import { setAlert } from '../../store/alert';

function About() {
	const dispatch = useDispatch();

	const about = useSelector((state) => state.about.data);
	const webSettings = useSelector((state) => state.webSettings.data);

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
		if (!about) {
			loadData();
		}
	}, []);
	function loadData() {
		setLoading(true);
		setError('');
		fetch
			.get('getWebSiteAboutUs')
			.then((res) => {
				setLoading(false);
				dispatch(setAbout(res.list));
			})
			.catch((err) => {
				setLoading(false);
				dispatch(setAlert({ type: 'error', message: err.message }));
				setError(err.message);
			});
	}
	return (
		<div className="main-body about-body">
			<section className="plain-title">
				<h3>About Us</h3>
			</section>
			<div className="sections">
				{loading && <Loading />}
				{error && <p style={{ padding: '20px', color: 'red' }}>An error occurred fetching About Us!! {error}</p>}
			</div>
			{about &&
				about.map((section, index) => (
					<div key={index}>
						<div className="sections each-about">
							<div className="img-preview" style={{ backgroundImage: `url(${webSettings.WEB_SITE_LOGO || section.VALUE1})` }}></div>
							<div className="info">
								<p>{section.VALUE2}</p>
							</div>
						</div>
						<div className="sections each-about">
							<div className="info">
								<p>{section.VALUE4}</p>
							</div>
							<div className="img-preview" style={{ backgroundImage: `url(${webSettings.WEB_SITE_LOGO || section.VALUE3})` }}></div>
						</div>
					</div>
				))}
		</div>
	);
}

export default React.memo(About);
